import React, { useEffect, useState } from "react";
import moment from "moment";
import { IMicrochipRegistrationResponseModel } from "../../../typings/models/MicrochipRegistrationResponseModel";
import { Link, useNavigate } from "react-router-dom";
import { getScientificNames } from "../../../api/apimethods";
import { IProductCodeMasterModel } from "../../../typings/models/ProductCodeMasterModel";

interface GridRowProps {
  data: IMicrochipRegistrationResponseModel;
  registrationType: number;
  scientificNames: Option[];
}

interface Option {
  value: string;
  label: string;
}

const CITESGridRow: React.FC<GridRowProps> = ({
  data,
  registrationType,
  scientificNames,
}) => {
  let navigate = useNavigate();
  // const [scientificNames, setScientificNames] = useState<Option[]>([]);

  const handleViewClick = (id: string) => {
    let path = `/application-registration`;
    navigate(path, {
      state: { id: id, mode: "view", registrationType: registrationType },
    });
  };

  // useEffect(() => {
  //
  //   const scientificNames = async () => {
  //     var response = null;
  //     var category = "Birds";
  //     if (registrationType === 1) category = "Birds";
  //     else if (registrationType === 2) category = "Crocodile";
  //     else if (registrationType === 3) category = "DragonFish";
  //     response = await getScientificNames(category);
  //     if (response.data) {
  //       const data = response.data;

  //       // Assuming your API response has an array of options
  //       const apiOptions: Option[] = data.map((item: any) => ({
  //         value: item.id.toString(),
  //         label: item.scientificNameCommonName,
  //       }));

  //       setScientificNames(apiOptions);
  //     }
  //   };
  //   scientificNames();
  // }, []);

  const findArrayElementByTitle = (
    value: string,
    scientificNames: Option[]
  ) => {
    var scientificName = scientificNames.find((el) => el.value === value);
    if (scientificName != undefined) return scientificName.label;
  };

  return (
    <tr>
      <td>{data.registrationReferenceNumber}</td>
      <td>{data.legRingTagMicrochipNo}</td>
      <td>{data.name}</td>
      {(registrationType === 1 || registrationType === 2) && (
        <td>{findArrayElementByTitle(data.scientificName, scientificNames)}</td>
      )}
      {(registrationType === 1 || registrationType === 2) && (
        <td>{data.citesAppendix}</td>
      )}
      {registrationType === 3 && <td>{data.batchNumberString}</td>}
      {registrationType === 3 && <td>{data.registeredQuantityinBatch}</td>}
      {(registrationType === 1 || registrationType === 2) && (
        <td>{data.foreignCITESPermitNo}</td>
      )}
      {registrationType === 3 && <td>{data.harvestDateString}</td>}
      {registrationType === 1 && <td>{data.hatchDateString}</td>}
      <td>
        {/* <a href="#" onClick={() => handleViewClick(data.id)}>
          View
        </a> */}
        <Link
          to="/application-registration"
          state={{
            id: data.id,
            mode: "view",
            RegistrationType: registrationType,
          }}
        >
          View
        </Link>
      </td>
      {/* Add other data fields here */}
    </tr>
  );
};

export default CITESGridRow;
